module.exports = __webpack_public_path__ + "static/media/77.e0ab4221.jpg";